import React, { useState } from "react";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import CalculatorInput from "../CalculatorInput/CalculatorInput";
import MaleOrFemale from "../MaleOrFemale/MaleOrFemale";
import CalculatorResult from "../CalculatorResult/CalculatorResult";
import metabolismData from "./metabolismData";

export default function Metabolism() {
  const [ageVal, setAgeVal] = useState(0);
  const [heightVal, setHeightVal] = useState(0);
  const [weightVal, setWeightVal] = useState(0);
  const [showAgeTooltip, setShowAgeTooltip] = useState(false);
  const [showHeightTooltip, setShowHeightTooltip] = useState(false);
  const [showWeightTooltip, setShowWeightTooltip] = useState(false);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [sex, setSex] = useState("female");
  const [result, setResult] = useState(0);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const handleInputChange = (val, inputName) => {
    if (inputName === "age") {
      setAgeVal(val);
      setShowAgeTooltip(true);
    } else if (inputName === "height") {
      setHeightVal(val);
      setShowHeightTooltip(true);
    } else {
      setWeightVal(val);
      setShowWeightTooltip(true);
    }
  };

  const handleTouchEnd = (inputName) => {
    if (inputName === "age") {
      setShowAgeTooltip(false);
    } else if (inputName === "height") {
      setShowHeightTooltip(false);
    } else {
      setShowWeightTooltip(false);
    }
  };

  const changeGender = (gender) => {
    setSex(gender);
  };

  const handleComputing = () => {
    let BMR = 0;
    //Male
    if (sex === "male") {
      BMR = (
        88.362 +
        13.397 * weightVal +
        4.799 * heightVal -
        5.677 * ageVal
      ).toFixed(3);
      BMR = parseFloat(BMR).toString();
      //Female
    } else if (sex === "female") {
      BMR = (
        447.593 +
        9.247 * weightVal +
        3.098 * heightVal -
        4.33 * ageVal
      ).toFixed(3);
      BMR = parseFloat(BMR).toString();
    }
    setResult(BMR);
  };
  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn path="/calculator" />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="pageTitle horizontalBorder">
            میزان متابولیک پایه (BMR)
          </div>
          <div className="scroll responsiveWidth calculatorPadding">
            <MaleOrFemale
              sex={sex}
              onTransGender={(gender) => changeGender(gender)}
            />
            {metabolismData.map((data) => (
              <CalculatorInput
                key={data.id}
                {...data}
                value={
                  data.name === "سن"
                    ? ageVal
                    : data.name === "قد"
                    ? heightVal
                    : weightVal
                }
                showTooltip={
                  data.name === "سن"
                    ? showAgeTooltip
                    : data.name === "قد"
                    ? showHeightTooltip
                    : showWeightTooltip
                }
                onChangeVal={(val) =>
                  handleInputChange(
                    val,
                    data.name === "سن"
                      ? "age"
                      : data.name === "قد"
                      ? "height"
                      : "weight"
                  )
                }
                onHide={() =>
                  handleTouchEnd(
                    data.name === "سن"
                      ? "age"
                      : data.name === "قد"
                      ? "height"
                      : "weight"
                  )
                }
              />
            ))}
            <CalculatorResult
              title="میزان متابولیک پایه (BMR)"
              onCompute={handleComputing}
              result={result}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
